export default "__VITE_ASSET__Ba9k5g3f__"